import { useMemo } from 'react';

import { useFlowContext } from './useFlowContext';
import { createCurrentStepUrl } from '../utils/createFlowUrl';

export const useFlowCurrentStepUrl = () => {
  const context = useFlowContext();

  return useMemo(() => createCurrentStepUrl(context), [context]);
};
